import { render, staticRenderFns } from "./EmbeddingItem.vue?vue&type=template&id=083f328e&scoped=true&"
import script from "./EmbeddingItem.vue?vue&type=script&lang=js&"
export * from "./EmbeddingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f328e",
  null
  
)

export default component.exports